export default {
  // 图片改变时触发
  'on-change' (h, conf) {
    return (file, fileList) => {
      const sizeNum = conf.size || 10
      const isLt10M = file.size / 1024 / 1024 < sizeNum
      if (!isLt10M) {
        this.$message.warning(`上传图片大小不能超过 ${sizeNum} MB!`)
        fileList.splice(fileList.findIndex(v => v.uid === file.uid), 1)
        return false
      }
      this.$emit('input', fileList)
    }
  },
  'on-exceed' (h, conf) {
    return (file, fileList) => {
      const limit = conf.limit
      this.$message.warning(`上传图片数量不能超过 ${limit} 张!`)
    }
  },
  'on-remove' () {
    return (file, fileList) => {
      this.$emit('input', fileList)
    }
  }
}
